import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import { getBaseEndpoint } from "../endpoints/endpointManager"
import { getUserRecord, updateUser } from "../../domain/Account/userSlice"
import { RootState } from "../../reduxStore/store"

interface TOUData {
  version: string
  timestamp: string
}
type TOUDataStatus = "loading" | "loaded" | "sending"
export enum TOUStatusEnum {
  ACCEPTED = "accepted",
  NOT_ACCEPTED = "notAccepted",
}

interface TermsOfUseState {
  dataStatus: TOUDataStatus
  status: TOUStatusEnum
  data: TOUData
}

export const initialTOUState: TermsOfUseState = {
  dataStatus: "loading",
  status: TOUStatusEnum.NOT_ACCEPTED,
  data: {
    version: "",
    timestamp: "",
  },
}

export const getUsersEndpoint = (): string => {
  return getBaseEndpoint() + `/account/users`
}

export const postData = createAsyncThunk(
  "termsOfUse/postData",
  async (
    {
      payload,
    }: {
      payload: {
        userId: string
        touFilename: string
        email: string
        givenName: string
        surname: string
        isHaUser: boolean
      }
    },
    { dispatch },
  ) => {
    try {
      const url: string = getUsersEndpoint()

      const response = await axios.post(url, {
        ...payload,
      })

      if (response.status === 201) {
        const data = response.data
        const userId = data.id
        await dispatch(getUserRecord(payload.userId))
        dispatch(
          updateUser({
            id: userId,
            name: `${data.givenName} ${data.surname}`,
            email: data.email,
            roles: data.userRoles.$values,
          }),
        )
      }
    } catch (error) {
      console.error(error)
    }
  },
)

const termsOfUseSlice = createSlice({
  name: "termsOfUse",
  initialState: initialTOUState,
  reducers: {
    dataUpdated: (state, { payload }: PayloadAction<TOUData>) => {
      state.data = payload
      state.dataStatus = "loaded"
    },
    dataStatusUpdated: (state, { payload }: PayloadAction<TOUDataStatus>) => {
      state.dataStatus = payload
    },
    statusUpdated: (state, { payload }: PayloadAction<TOUStatusEnum>) => {
      state.status = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUser, (state, action) => {
      if (action.payload.touAcceptDateTime && action.payload.touFilename) {
        state.data = {
          timestamp: action.payload.touAcceptDateTime,
          version: "0.0",
        }
        state.status = TOUStatusEnum.ACCEPTED
        state.dataStatus = "loaded"
      }
    })
  },
})

export const selectDataStatus = (state: RootState) =>
  state.termsOfUse.dataStatus

export const selectStatus = (state: RootState) => state.termsOfUse.status

export const { dataUpdated, statusUpdated, dataStatusUpdated } =
  termsOfUseSlice.actions

export default termsOfUseSlice.reducer
